/*
 * WW Timeline — phone card pairing
 * Author: Plaud Tayler — 2026-09-10
 * Version: 1.1.0 - 2026-09-18 16:25 (UTC+8) - Plaud Tayler — the gate matches the stylesheet's 768.98; at 768 the CSS expected cards this file had not built
 * Version-note: 1.0.0 - 2026-09-10 17:40 (UTC+8) - Plaud Tayler — initial
 *
 * Figma 1637:17530 lays each chapter out on a phone as a horizontally scrolling row of cards, and
 * every card is ONE photo with ITS OWN caption underneath it. The markup pairs them the other way
 * round on purpose: all captions live in .ww-tl__subs inside the left column, all photos in
 * .ww-tl__media, because the desktop scene drifts the one past the other and needs them as two
 * independent groups. Stacked naively for a phone that ordering reads as heading, caption 1,
 * caption 2, photo 1, photo 2 — every caption divorced from the photo it describes.
 *
 * A CSS-only fix was tried first and abandoned: display:contents on the two wrappers does promote
 * the children into one grid, but the scene's own track sizing then collapsed the header and the
 * captions to zero width. Pairing the nodes is the honest way to say what the comp says, so it is
 * done here — at the phone tier only, and undone on the way back up, so no width above 768 ever
 * sees a DOM this file has touched.
 */
(function () {
  if (window.__wwTimelineCards) return;
  window.__wwTimelineCards = true;

  /* 768.98, matching the stylesheet - Plaud Tayler - 2026-09-18 16:25
     This gate was 767.98 while ww-timeline.css's phone tier is 768.98, so at exactly 768 the CSS
     laid the chapter out as cards that this file had never built: the photo kept the raw phone
     rules, took the column's full 721 and, at a 340/480 crop, came out 1018 tall inside a pinned
     scene with 791 to give. The two gates have to be the same number. */
  var mq = window.matchMedia('(max-width: 768.98px)');

  function kids(parent, sel) {
    return [].filter.call(parent.children, function (el) { return el.matches(sel); });
  }

  function pair(stage) {
    var media = stage.querySelector('.ww-tl__media');
    var subs = stage.querySelector('.ww-tl__subs');
    if (!media || kids(media, '.ww-tl__card').length) return;
    var shapes = kids(media, '.ww-tl__shape');
    var caps = subs ? kids(subs, '.ww-tl__sub') : [];
    if (!shapes.length) return;
    shapes.forEach(function (shape, i) {
      var card = document.createElement('div');
      card.className = 'ww-tl__card';
      media.insertBefore(card, shape);
      card.appendChild(shape);
      /* A chapter can carry more photos than captions; the extra cards are simply photo-only. */
      if (caps[i]) card.appendChild(caps[i]);
    });
  }

  function unpair(stage) {
    var media = stage.querySelector('.ww-tl__media');
    var subs = stage.querySelector('.ww-tl__subs');
    if (!media) return;
    kids(media, '.ww-tl__card').forEach(function (card) {
      var shape = kids(card, '.ww-tl__shape')[0];
      var cap = kids(card, '.ww-tl__sub')[0];
      if (shape) media.insertBefore(shape, card);
      if (cap && subs) subs.appendChild(cap);
      card.parentNode.removeChild(card);
    });
  }

  function apply() {
    var fn = mq.matches ? pair : unpair;
    [].forEach.call(document.querySelectorAll('.ww-tl__stage'), fn);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
  if (mq.addEventListener) mq.addEventListener('change', apply);
  else if (mq.addListener) mq.addListener(apply);
})();
